import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const Title = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  return (
    <Stack gap='10px'>
      <Typography
        fontSize={isDesktop ? '18px !important' : '16px !important'}
        sx={{
          fontWeight: 'bold',
        }}
      >
        {dictionary.sixthSectionTitle}
      </Typography>
      <Typography>{dictionary.sixthSectionTitleDesc}</Typography>
    </Stack>
  );
};
